import * as types from '../mutation-types'
import questionVisibility from '@/api/questionVisibility'

const state = {
  questionVisibility: null
}

const getters = {
  questionVisibility: state => state.questionVisibility !== null ? state.questionVisibility : {}
}

const actions = {
  getQuestionVisibility ({ commit, dispatch }, { userID, userType }) {
    return new Promise((resolve, reject) => {
      questionVisibility.getQuestionVisibility(userID, userType).then((response) => {
        const questionVisibility = response.data.result.questionVisibility
        commit(types.SET_USER_QUESTION_VISIBILITY, questionVisibility)
        resolve(questionVisibility)
      }, (error) => {
        reject(error)
      })
    })
  }
}

const mutations = {
  [types.SET_USER_QUESTION_VISIBILITY] (state, questionVisibility) {
    state.questionVisibility = questionVisibility
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
